import { createSelector } from 'reselect'
import { selectCurrentUserPrefersAutoadvanceToNextTicket } from './selectCurrentUserPrefersAutoadvanceToNextTicket'
import { selectPrefersClassicView } from './selectPrefersClassicView'

export const selectAutoAdvanceToNextTicketInList = createSelector(
  selectPrefersClassicView,
  selectCurrentUserPrefersAutoadvanceToNextTicket,
  (classicView, advance) => !classicView && advance
)
